import { AuthSuccessGrant } from '@src/utils/cheggAuth'
import { Cookies, getCookie } from '@src/utils/cookies'
import { cfeLogin } from '@src/state/auth/actions'
import { useDispatch, useSelector } from 'react-redux'
import { AuthActionType } from '@chegg/one-auth-sdk'
import {
  getPaidMember,
  getUserRole,
  selectAuthFlowInProgress,
} from '@src/state/auth/selectors'
import { useEffect, useState } from 'react'
import { featureFlagsSelector } from '@src/state/featureFlags/selectors'
import { isAppInitialized } from '@src/state/app/selectors'
import { loadFromLocalStorage } from '@src/state/session/actions'
import { getWFELS } from '@src/utils/localStorage'
import { RootState } from '@src/state/types'

export const useAuthenticationHook = () => {
  const dispatch = useDispatch()
  const search = useSelector((state: RootState) => state.router.location.search)

  // Parse query parameters
  const queryParams = new URLSearchParams(search)
  const authSuccess = queryParams.get('authSuccess')
  const authTypeParam = queryParams.get('auth_type')

  const authType: AuthActionType | 'login' =
    authTypeParam === 'signin' ? 'login' : (authTypeParam as AuthActionType) ?? 'login'

  const idToken = getCookie(Cookies.IdToken)
  const accessToken = getCookie(Cookies.AccessToken)
  const role = useSelector(getUserRole)
  const authComplete = useSelector(selectAuthFlowInProgress)
  const paidMember = useSelector(getPaidMember)
  const featureFlag = useSelector(featureFlagsSelector)
  const isAppInitializationdone = useSelector(isAppInitialized)
  const [isProcessed, setIsProcessed] = useState(false)

  const checkAuth = async () => {
    if (
      authSuccess === 'true' &&
      idToken &&
      accessToken &&
      !authComplete &&
      isAppInitializationdone &&
      !isProcessed
    ) {
      const successResponse: AuthSuccessGrant = {
        id_token: idToken as string,
        access_token: accessToken as string,
        auth_type: authType as AuthActionType,
        auth_flow: 'code',
        auth_method: 'Chegg',
        redirect_uri: window.location.href,
      }
      try {
        const wfeLs = getWFELS()
        if (wfeLs) {
          dispatch(loadFromLocalStorage(wfeLs))
        }

        await dispatch(cfeLogin(successResponse))

        setIsProcessed(true)
      } catch (error) {
        console.error('Error in useAuthenticationHook', error)
      }
    }
  }

  useEffect(() => {
    checkAuth()
  }, [
    authSuccess,
    idToken,
    accessToken,
    authComplete,
    authType,
    dispatch,
    featureFlag,
    isAppInitializationdone,
    role,
    paidMember,
    checkAuth,
    isProcessed,
  ])
}



// WEBPACK FOOTER //
// ./src/hooks/useAuthenticationHook.tsx